var isModalOpenState;
function showHideresultsFilterMenu(action) {
  var facetsDrawer = document.querySelector('facetsDrawer');
  
  if (action == 'open') {
    document.body.style.overflow = 'hidden';
    facetsDrawer.classList.add('is-open');
  } else if (action == 'close') {
    document.body.style.overflow = '';
    facetsDrawer.classList.remove('is-open');
  }
}



function onchangeFilterAndSortOptions(filterFormId, action = 'change', customUrl = '') {
  var formDatarow = new FormData(document.getElementById(filterFormId));
  

  try {
    var rootResultsRow = document.getElementById('results_main__product_grid_box').dataset.url;
    var rootResultsType = document.getElementById('results_main__product_grid_box').dataset.type;
    if (action == 'change') {
      var formData = [...formDatarow.entries()];
      var formDataAsStringRow = formData
        .filter(([name, value]) => value.trim() !== '') // Filter out blank values
        .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`);
      var formDataAsString = [...new Set(formDataAsStringRow)].join('&');

      if (formDataAsString !== '') { // Only construct URL parameters if not empty
        var urlParamAsString =
          document.getElementById('results_main__product_grid_box').dataset.section + `&` + formDataAsString;
        if (rootResultsRow.includes('?')) {
          var resultsUrlRender = rootResultsRow + `&` + urlParamAsString;
          var resultsUrlHistory = rootResultsRow + `&` + formDataAsString;
        } else {
          var resultsUrlRender = rootResultsRow + `?` + urlParamAsString;
          var resultsUrlHistory = rootResultsRow + `?` + formDataAsString;
        }
        window.history.pushState({}, '', resultsUrlHistory);
        renderSectionFromFetch(resultsUrlRender);
      }
    } else {
      if (rootResultsType == 'search') {
        customUrl = customUrl.replace(`?`, `&`);
        var finalCustomUrlOnSearch = rootResultsRow + customUrl;
        renderSectionFromFetch(finalCustomUrlOnSearch);
        window.history.pushState({}, '', finalCustomUrlOnSearch);
      } else {
        renderSectionFromFetch(customUrl);
        window.history.pushState({}, '', customUrl);
      }
    }
  } catch (e) {
    document.getElementById(filterFormId).submit();
  }
}

function renderSectionFromFetch(url) {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {

      const html = new DOMParser().parseFromString(responseText, 'text/html');
      var id = 'main__results_product_main_container';
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        // if(isModalOpenState){
        //   showHideresultsFilterMenu('close')
        // }
        showHideresultsFilterMenu('close')
        showLoader(false);
      }
    });
}


class FacetsAction extends HTMLElement {
  constructor() {
    super();
    this._handleSort = this._handleSort.bind(this);
  }

  connectedCallback() {
    this.allSortOptions = this.querySelectorAll('.sort-input-options');
    this.allSortOptions.forEach((option) => {
      option.addEventListener('change', this._handleSort);
    });
  }
  _handleSort(event) {
    const filterFormId = event.target.dataset.targetform;
    showLoader(true);
    onchangeFilterAndSortOptions(filterFormId);
  }
}

customElements.define('facets-action', FacetsAction);



class FacetsFilter extends HTMLElement {
  constructor() {
    super();
    this._handleFilter = this._handleFilter.bind(this);
    this._handlePriceFilter = this._handlePriceFilter.bind(this);
  }

  connectedCallback() {
    this.allFilterOptions = this.querySelectorAll('.filter-input-options');
    this.priceRangeInput = this.querySelectorAll('.price-range-input');

    this.allFilterOptions.forEach((option) => {
      option.addEventListener('click', this._handleFilter);
    });

    this.priceRangeInput.forEach((inputElement) => {
      inputElement.addEventListener('change', this._handlePriceFilter);
      inputElement.addEventListener('focusout', this._handlePriceFilter);
    });
  }

  _handleFilter(event) {
    const filterFormId = event.target.dataset.targetform;
    showLoader(true);
    onchangeFilterAndSortOptions(filterFormId);
  }

  _handlePriceFilter(event) {
    const inputTarget = event.target;
    var isValueChanged = false;

    if (event.type === 'change') {
      isValueChanged = true;
    } else if (event.type === 'focusout') {
      if (Number(inputTarget.max) < Number(inputTarget.value)) {
        inputTarget.value = inputTarget.max;
      } else if (Number(inputTarget.max) - 1 < Number(inputTarget.value)) {
        inputTarget.value = inputTarget.max - 1;
      }
      isValueChanged = true;
    }

    if (isValueChanged) {
      const filterFormId = inputTarget.dataset.targetform;
      showLoader(true);
      onchangeFilterAndSortOptions(filterFormId);
    }
  }
}

customElements.define('facets-filter', FacetsFilter);

class FacetsActiveFilters extends HTMLElement {
  constructor() {
    super();
    this._handleRemove = this._handleRemove.bind(this);
  }

  connectedCallback() {
    this.removeAllOptions = this.querySelectorAll('.remove-filter-options');
    this.removeAllOptions.forEach((option) => {
      option.addEventListener('click', this._handleRemove);
    });
  }
  _handleRemove(event) {
    var targetElement = event.target.closest('.remove-filter-options')
    var removeUrl = targetElement.dataset.removeuri;
    var filterFormId = targetElement.dataset.targetform;
    showLoader(true);
    onchangeFilterAndSortOptions(filterFormId, 'delete', removeUrl);
  }
}

customElements.define('facets-active-filter', FacetsActiveFilters);

class facetsDrawerOpener extends HTMLElement {
  constructor() {
    super();
    this._handleDrawer = this._handleDrawer.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this._handleDrawer);
  }
  _handleDrawer(event) {
    const targetId = event.target.closest('.facets-opener').dataset.drawer;
    const targetDrawer = document.querySelector(`#${targetId}`);
    targetDrawer.classList.add('is-open');
    isModalOpenState = true;
    targetDrawer.dataset.state = "open"
  }
}

customElements.define('facets-opener', facetsDrawerOpener);

class facetsDrawerClose extends HTMLElement {
  constructor() {
    super();
    this._handleDrawer = this._handleDrawer.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this._handleDrawer);
  }
  _handleDrawer(event) {
    const targetId = event.target.closest('.facets-close').dataset.drawer;
    const targetDrawer = document.querySelector(`#${targetId}`);
    targetDrawer.classList.remove('is-open');
    isModalOpenState = false;
    targetDrawer.dataset.state = "close"

  }
}

customElements.define('facets-close', facetsDrawerClose);
